import {Component, Input, OnInit} from '@angular/core';

import {TranslateDirective} from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  imports: [TranslateDirective],
})
export class NotFoundComponent implements OnInit {
  @Input() pageTitle = 'not found.label';
  constructor() {}

  ngOnInit(): void {}
}
